import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateInfoBarData } from "./updateInfoBarData.request";

const useUpdateInfoBarData = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateInfoBarData,
    ...options
  });
};

export default useUpdateInfoBarData;
